import {
  SESSION_HAS_ANDROID_TWA_REFERRER_KEY,
  SESSION_HAS_PLAYSTORE_TWA_HASH_KEY,
  SESSION_IS_STANDALONE_MODE_KEY,
  TWA_PACKAGE_NAME,
  TWA_START_URL_HASH,
} from './constants';

// For PWA/TWA install detection,
// see https://thomashunter.name/posts/2021-12-11-detecting-if-pwa-twa-is-installed
// and https://micahjon.com/2021/pwa-twa-detection/

const UA = window?.navigator?.userAgent;
const IOS = UA?.match(/iPhone|iPad|iPod/);
const ANDROID = UA?.match(/Android/);

export const PLATFORM = IOS ? 'ios' : ANDROID ? 'android' : 'unknown';

// PWA Detection

let hasBeenInStandaloneMode: boolean;
if (isInStandaloneMode()) { // Run this before user has a chance to change display mode
  hasBeenInStandaloneMode = true;
  // Use session storage to avoid sharing PWA session status state with browser
  sessionStorage.setItem(SESSION_IS_STANDALONE_MODE_KEY, 'true');
} else {
  hasBeenInStandaloneMode = sessionStorage.getItem(SESSION_IS_STANDALONE_MODE_KEY) === 'true';
}
export const IS_INSTALLED = !!(hasBeenInStandaloneMode || (IOS && !UA?.match(/Safari/)));

export function isInstalledPwaSession() {
  return !!hasBeenInStandaloneMode;
}

/**
 * Is the page currently in standalone display mode (used by PWA)?
 */
function isInStandaloneMode() {
  return Boolean(
    window?.matchMedia('(display-mode: standalone)').matches
      || (window?.navigator as Navigator & { standalone?: boolean; })?.standalone, // Fallback for iOS
  );
}

// TWA Detection

let isAndroidTwaSession: boolean;
if (document.referrer.includes(`android-app://${TWA_PACKAGE_NAME}`)) {
  isAndroidTwaSession = true;
  sessionStorage.setItem(SESSION_HAS_ANDROID_TWA_REFERRER_KEY, 'true');
} else {
  isAndroidTwaSession = sessionStorage.getItem(SESSION_HAS_ANDROID_TWA_REFERRER_KEY) === 'true';
}

// Check for #playstore-twa hash in start URL to identify TWA
let hasPlayStoreTwaHash: boolean;
if (window.location.hash === TWA_START_URL_HASH) {
  hasPlayStoreTwaHash = true;
  sessionStorage.setItem(SESSION_HAS_PLAYSTORE_TWA_HASH_KEY, 'true');
} else {
  hasPlayStoreTwaHash = sessionStorage.getItem(SESSION_HAS_PLAYSTORE_TWA_HASH_KEY) === 'true';
}

export function isTwaSession() {
  return hasPlayStoreTwaHash || isAndroidTwaSession;
}

// Google Play Billing Detection

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getDigitalGoodsService: (url: string) => Promise<any>;
  }
}

/**
 * Check if we are running in the Android app via Google Play
 */
export function hasGooglePlayBilling() {
  const hasDigitalGoodsService = window?.getDigitalGoodsService !== undefined;
  return hasDigitalGoodsService; // assume all Android devices have Google Play Billing for simplicity for now
  // if (!hasDigitalGoodsService) return false;

  // try {
  //   const isGooglePlayBilling = await window.getDigitalGoodsService('https://play.google.com/billing');
  //   return !!isGooglePlayBilling;
  // } catch (_) {
  //   return false;
  // }
}